import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { injectIntl, IntlShape } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Aircraft } from '../../models/aircraft';
import { DashboardState } from '../../models';
import { Trip } from '../../models/trips';
import { UserSettingsState } from '../../models/userSettings';
import OverviewRecentTrips from './OverviewRecentTrips';
import { OverviewRecentTripsComponentProps } from './types';

// Props that will be passed to the component
interface TypedOverviewRecentTripsProps {
  aircraft?: Aircraft;
}

// Props that will come from Redux state
interface StateProps {
  tripUpdate: Trip | null;
  tripsArr: Trip[];
  userSettings: UserSettingsState;
}

// Props for dispatch actions
interface DispatchProps {
  dispatch: (action: AnyAction) => void;
}

const mapStateToProps = (
  state: DashboardState,
  ownProps: TypedOverviewRecentTripsProps
): StateProps => {
  const tripsArr = Array.from(state.trips.tripsMap.values())
    .filter((tripEntry) => ownProps.aircraft && tripEntry.aircraft_id === ownProps.aircraft.id)
    .sort((a, b) => moment(b.date).diff(moment(a.date)));

  return {
    tripUpdate: state.trips.newTrip || null,
    tripsArr,
    userSettings: state.userSettings,
  };
};

// Create the base component that will receive all props
const BaseOverviewRecentTrips = React.memo<
  OverviewRecentTripsComponentProps & { intl: IntlShape }
>((props) => {
  const {
    aircraft,
    tripUpdate,
    tripsArr,
    userSettings,
    intl,
    dispatch,
    history,
    location,
    match,
  } = props;

  // Use type assertion to handle the JavaScript component
  return React.createElement(OverviewRecentTrips, {
    aircraft: aircraft || null,
    tripUpdate,
    tripsArr,
    userSettings,
    intl,
    dispatch,
    history,
    location,
    match,
  } as OverviewRecentTripsComponentProps);
});

BaseOverviewRecentTrips.displayName = 'BaseOverviewRecentTrips';

// Create the connected and wrapped component
const ConnectedOverviewRecentTrips = connect<
  StateProps,
  DispatchProps,
  TypedOverviewRecentTripsProps,
  DashboardState
>(mapStateToProps)(BaseOverviewRecentTrips);

// Export the final component wrapped with router and intl
export default withRouter(injectIntl(ConnectedOverviewRecentTrips));
